module.exports = __webpack_public_path__ + "img/hx_bank_logo.c4b033fe.png";